import _taggedTemplateLiteral from '../../../../node_modules/@babel/runtime/helpers/taggedTemplateLiteral.es.js';
import { styled } from '@mgmresorts/wcl-styled';

var _templateObject;
var FlexColumn = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex: ", ";\n  max-width: ", "%;\n  ", "\n"])), function (p) {
  return p.fixed ? 1 : "0 0 ".concat((p.cols || 0) / (p.totalCols || 12) * 100, "%");
}, function (p) {
  return (p.cols || 0) / (p.totalCols || 12) * 100;
}, function (p) {
  return p.indent ? "margin-left: ".concat((p.indent || 0) / (p.totalCols || 12) * 100, "%;") : '';
});
FlexColumn.defaultProps = {
  cols: 1,
  totalCols: 12,
  indent: 0
};

export { FlexColumn };
